import { render } from "./SubcategoriesList.vue?vue&type=template&id=a6e91ffc"
import script from "./SubcategoriesList.vue?vue&type=script&lang=js"
export * from "./SubcategoriesList.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__